import { _DeepPartialObject } from 'chart.js/dist/types/utils';
import { LegendOptions } from 'chart.js';
import colors from 'src/integration/styles/colors';
import fonts from 'src/integration/styles/fonts';
import { deviceSize } from 'src/integration/styles/breakpoints';

const chartTypographyScale4K = 1.5;

export const getChartTypographyScale = () => {
  if (typeof window === 'undefined') {
    return 1;
  }

  return window.innerWidth >= deviceSize.desktopLarge4K ? chartTypographyScale4K : 1;
};

export const scaleChartSize = (size: number, scale = getChartTypographyScale()) => Math.round(size * scale);

export const getLegendSettings = (
  scale = getChartTypographyScale()
): _DeepPartialObject<LegendOptions<'bar' | 'line'>> => ({
  display: true,
  position: 'top',
  align: 'start',
  labels: {
    usePointStyle: true,
    pointStyle: 'circle',
    boxWidth: scaleChartSize(30, scale),
    boxHeight: scaleChartSize(20, scale),
    padding: scaleChartSize(10, scale),
    color: colors.primaryDarkJungleGreen,
    font: {
      family: fonts.fontFamily.body,
      size: scaleChartSize(14, scale),
    },
  },
});

export const getXScaleSettings = (scale = getChartTypographyScale()) => ({
  stacked: true,
  title: {
    display: false,
  },
  grid: {
    display: false,
  },
  ticks: {
    maxRotation: 45,
    minRotation: 45,
    color: colors.primaryDarkJungleGreen,
    font: {
      family: fonts.fontFamily.body,
      size: scaleChartSize(12, scale),
    },
  }
});

export const getYScaleSettingsTicks = (scale = getChartTypographyScale()) => ({
  color: colors.primaryDarkJungleGreen,
  font: {
    family: fonts.fontFamily.body,
    size: scaleChartSize(14, scale),
  },
});

export const yScaleSettings = {
  stacked: true,
  title: {
    display: false,
  },
};